import React from "react";
import { Else, If } from "react-condition";
import Loading from "./Loading";

function LoadingArea({ children = <div></div>, isLoading }) {
  if (children == null) {
    children = <div></div>;
  }
  return (
    <If test={isLoading === false}>
      {children}
      <Else>
        <Loading />
      </Else>
    </If>
  );
}

export default LoadingArea;
